import { languages } from './languages';

// Get the current language from the HTML lang attribute
const getCurrentLanguage = () => {
  return document.documentElement.lang || 'nl';
};

// Simple translation function
export const translate = (key, parameters = {}) => {
  const currentLang = getCurrentLanguage();
  const fallbackLang = 'nl';
  
  // Try to get translation for current language
  let translation = languages[currentLang]?.[key];
  
  // If not found, try fallback language
  if (!translation && currentLang !== fallbackLang) {
    translation = languages[fallbackLang]?.[key];
  }
  
  // If still not found, return the key itself
  if (!translation) {
    console.warn(`Translation key not found: ${key}`);
    return key;
  }
  
  // Replace parameters if any
  if (parameters && Object.keys(parameters).length > 0) {
    Object.keys(parameters).forEach(param => {
      translation = translation.replace(`{${param}}`, parameters[param]);
    });
  }
  
  return translation;
};

// Function to change the language
export const setLanguage = (lang) => {
  if (languages[lang]) {
    document.documentElement.lang = lang;
    // Trigger a page refresh to update all translations
    window.location.reload();
  } else {
    console.error(`Language not supported: ${lang}`);
  }
};

// Export the current language
export const getLanguage = getCurrentLanguage;
